<template>
  <div :class="classes()">
    <div :class="`${el}__bgLayer`" @click="() => close('background')" />
    <div :class="`${el}__contentOuter`">
      <div>
        <div :class="`${el}__content`">
          <Icon
            v-if="!notClosable"
            :class="`${el}__close`"
            name="close-line"
            :onClick="() => close('icon')"
            size="l"
            color="primaryBlue"
          />
          <Headline v-if="headline" size="s" :staticClass="`${el}__headline`" responsive>
            {{ headline }}
          </Headline>
          <slot />
          <div v-if="closeBtnText" :class="`${el}__closeBtn`">
            <Button :label="closeBtnText" type="outlined" :onClick="close" small />
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Icon from '@/objects/Icon';
import Headline from '@/objects/Headline';
import Button from '@/objects/Button';
export default {
  name: 'Modal',
  props: {
    open: Boolean,
    size: {
      type: String,
      default: 'l',
      validator: (val) => ['l', 'm', 's', 'xs'].includes(val),
    },
    onClose: Function,
    noBackground: Boolean,
    noPadding: Boolean,
    notClosable: Boolean,
    overflow: Boolean,
    closeBtnText: String,
    headline: String,
  },
  components: {
    Icon,
    Headline,
    Button,
  },
  data() {
    return {
      height: 0,
      windowHeight: 0,
      el: 'c-modal',
      classes: () => {
        const el = this.el;
        return {
          [el]: true,
          'is-active': this.open,
          [`${el}--${this.size}`]: this.size,
          [`${el}--static`]: this.windowHeight < this.height,
          [`${el}--noPadding`]: this.noPadding,
          [`${el}--overflow`]: this.overflow,
        };
      },
    };
  },
  mounted() {
    this.handleResize();
    window.addEventListener('resize', this.handleResize);
  },
  beforeDestroy() {
    document.body.style.overflow = '';
    window.removeEventListener('resize', this.handleResize);
  },
  watch: {
    open: function () {
      if (!this.open) {
        // this.close();
        document.body.style.overflow = '';
      } else {
        document.body.style.overflow = 'hidden';
        this.$nextTick(() => {
          const contentHeight = this.$el
            .querySelector(`.${this.el}__content`)
            .getBoundingClientRect().height;
          this.height = contentHeight + 300;
        });
      }
    },
  },
  methods: {
    handleResize() {
      this.windowHeight = window.innerHeight;
    },
    close(src) {
      if (!this.notClosable) {
        this.$emit('close');
        this.$emit('onTrackingClick', src);
      }
    },
  },
};
</script>
